import { render, staticRenderFns } from "./task-drawer.vue?vue&type=template&id=5f2f57c5&"
import script from "./task-drawer.vue?vue&type=script&lang=js&"
export * from "./task-drawer.vue?vue&type=script&lang=js&"
import style0 from "./task-drawer.vue?vue&type=style&index=0&id=5f2f57c5&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports